export default "__VITE_ASSET__d866d665__"